import React from 'react';
import logo from "../logo.svg";

const ThankYou = () => {
  return (
    <div className="thank-you-content">
        {/* <img src={logo} alt="Logo" className="thank-you-app-logo" /> */}
        <h1 className="thank-you-title">Kamionosallasok.com</h1>
        <h2>Köszönjük a jelentkezést!</h2>
        <p>Hamarosan felvesszük önnel a kapcsolatot.</p>
        <p>Megerősítésként küldtünk önnek egy levelet.</p>
    </div>
  );
};

export default ThankYou;
